import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { defaultPathForJwtRole } from './role-routing.util';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthenticationService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!this.authService.isAuthenticated()) {
			this.router.navigate(['login']);
			return true;
		}

		let routeWithRoles = route;
		if (!routeWithRoles.data.roles) {
			// Traverse to find the child route that has roles data
			while (routeWithRoles.firstChild) {
				routeWithRoles = routeWithRoles.firstChild;
				if (routeWithRoles.data.roles) {
					break;
				}
			}
		}

		// Check if roles are defined and if user's role is authorized
		if (routeWithRoles.data.roles && routeWithRoles.data.roles.indexOf(this.authService.role) === -1) {
			this.router.navigate([defaultPathForJwtRole(this.authService.role)]);
			return false;
		}
		return true;
	}
}
